import { OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { EligibilityLetDown } from "../../components";
import { MESSAGES } from "../../components/eligibility-let-down/message-definitions";

export const IneligiblePage = () => {
  const intl = useIntl();

  return (
    <OnboardingLayout title={intl.formatMessage(MESSAGES.letDownTitle)}>
      <EligibilityLetDown />
    </OnboardingLayout>
  );
};
